export default function AOClpStickyMenu() {
  const initiate = () => {
    import(/* webpackChunkName: "StickyMenuNavigationDesktop" */'@atomic/organisms/sticky-menu/sticky-menu').then((module) => {
      const AOStickyMenu = module.default;

      const stickyNavigation = new AOStickyMenu();
      stickyNavigation.initiate();
    });
  };

  return { initiate };
}
